import { Link } from "react-router-dom"

export const BrandItem = ({ brand }) => {
    return (
        <Link className="card-item brand" to={"/products/" + brand.variantID}>
            <div className="card-img"><img src={brand.brandImageURL} alt={brand.brandName} /></div>
            <h5>{brand.brandName}</h5>
        </Link>
    )
}